<div class="flex h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-start justify-between px-6" [ngClass]="shortScreen ? 'pt-3' : 'pt-6'">
    <div>
      <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.PRODUCT_SEARCH_MODAL.TITLE' | t }}</h2>
      @if (!shortScreen) {
      <p class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.PRODUCT_SEARCH_MODAL.SUBTITLE' | t }}</p>
      }
    </div>
    <button mat-icon-button type="button" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- search -->
  <div class="px-6" [ngClass]="shortScreen ? 'py-2' : 'py-4'">
    <div class="flex items-center gap-3 rounded-xl border px-4 py-2">
      <mat-icon class="text-secondary">search</mat-icon>
      <input class="flex-1 bg-transparent outline-none" type="text"
        [placeholder]="'DOCUMENT_GENERATE.PRODUCT_SEARCH_MODAL.SEARCH_PLACEHOLDER' | t" [(ngModel)]="search"
        (keyup.enter)="onSearchEnter()" (keyup.escape)="cancel()" autofocus>
    </div>
  </div>

  <!-- seleccionados: reemplaza el listado mientras está activo -->
  @if (showingSelected) {
  <div class="min-h-0 flex-1 overflow-auto border-t p-4">
    @if (selectedList().length) {
    <div class="flex flex-col gap-2">
      @for (m of selectedList(); track m._id) {
      <div class="flex items-center gap-3 rounded-xl border p-3">
        <div class="flex min-w-0 flex-1 flex-col">
          <span class="text-primary text-sm font-semibold">{{ code(m) }}</span>
          <span class="truncate text-sm font-medium uppercase">{{ m.name }}</span>
          <span class="text-secondary text-xs">{{ unitName(m, unitId(m)) }}</span>
        </div>
        <span class="whitespace-nowrap text-base font-semibold">{{ quantityOf(m) ?? 1 }}</span>
        <button mat-icon-button type="button" [matTooltip]="'DOCUMENT_GENERATE.PRODUCT_SEARCH_MODAL.REMOVE' | t" (click)="removeSelected(m)">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
      }
    </div>
    } @else {
    <div class="text-secondary flex h-40 items-center justify-center text-sm">
      {{ 'DOCUMENT_GENERATE.PRODUCT_SEARCH_MODAL.NO_SELECTION' | t }}
    </div>
    }
  </div>
  } @else {

  <!-- results, móvil: tarjetas -->
  <div #cardsScroll class="min-h-0 flex-1 overflow-auto border-t p-3 md:hidden" cdkScrollable>
    @if (materials.length) {
    <div class="mb-3 flex items-center gap-2">
      <mat-checkbox [checked]="allSelected()" (change)="toggleAll($event.checked)"></mat-checkbox>
      <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.ITEMS_TABLE.SELECT_ALL' | t }}</span>
    </div>
    }
    <div class="flex flex-col gap-3">
      @for (m of materials; track m._id) {
      <div class="flex flex-col rounded-xl border bg-card p-3"
        [ngClass]="selectable(m) ? 'cursor-pointer' : 'opacity-50'"
        [class.border-primary]="isSelected(m)" [class.bg-primary-50]="isSelected(m)"
        [class.dark:bg-primary-900]="isSelected(m)" (click)="toggle(m)">
        <div class="flex items-start gap-2">
          <mat-checkbox class="-ml-2" [checked]="isSelected(m)" [disabled]="!selectable(m)"
            (change)="toggle(m)" (click)="$event.stopPropagation()"></mat-checkbox>
          <div class="flex min-w-0 flex-1 flex-col">
            <span class="inline-flex items-center gap-1.5 text-primary font-semibold">{{ code(m) }}<app-bom-cell [material]="m" /></span>
            <span class="text-sm font-medium uppercase">{{ m.name }}</span>
            @if (category(m)) {
            <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.PRODUCT_SEARCH_MODAL.CATEGORY_LABEL' | t }} {{ category(m) }}</span>
            }
          </div>
        </div>

        <div class="mt-3 flex flex-col gap-1 border-t pt-3" (click)="$event.stopPropagation()">
          <span class="text-secondary text-xs font-medium uppercase">{{ 'DOCUMENT_GENERATE.PLACEHOLDERS.UNIT' | t }}</span>
          <mat-form-field appearance="fill" subscriptSizing="dynamic" class="w-full">
            <input matInput [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.UNIT' | t" [matAutocomplete]="autoUnitCard" [disabled]="!selectable(m)"
              [ngModel]="unitSearchValue(m)" (ngModelChange)="onUnitInput(m, $event)" (blur)="onUnitBlur(m)">
            <mat-autocomplete #autoUnitCard="matAutocomplete" (optionSelected)="onUnitPick(m, $event.option.value)">
              @for (u of filteredUnits(m); track u.id) {
              <mat-option [value]="u.name">
                <span class="flex items-center gap-2">
                  <span class="truncate">{{ u.name }}</span>
                  @if (u.chip === 'BASE') {
                  <span class="rounded-full bg-green-100 px-2 py-0.5 text-[10px] font-semibold text-green-700 dark:bg-green-900/40 dark:text-green-300">{{ 'DOCUMENT_GENERATE.BADGES.BASE' | t }}</span>
                  } @else if (u.chip === 'SECUNDARIA') {
                  <span class="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-700 dark:bg-amber-900/40 dark:text-amber-300">{{ 'DOCUMENT_GENERATE.BADGES.SECONDARY' | t }}</span>
                  } @else if (u.chip === 'PARALELA') {
                  <span class="rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-semibold text-blue-700 dark:bg-blue-900/40 dark:text-blue-300">{{ 'DOCUMENT_GENERATE.BADGES.PARALLEL' | t }}</span>
                  }
                </span>
              </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          <div class="flex flex-wrap gap-x-3">
          @if (altUnits(m); as alt) {
          <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.COLUMNS.BASE_UOM_LABEL' | t: { value: hasQuantity(m) ? ((alt.umbQty | dgNumber: 'stock') + ' ' + alt.umbCode) : alt.umbCode } }}</span>
          @if (alt.umsQty != null) {
          <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.COLUMNS.SECONDARY_UOM_LABEL' | t: { value: hasQuantity(m) ? ((alt.umsQty | dgNumber: 'stock') + ' ' + alt.umsCode) : alt.umsCode } }}</span>
          }
          @if (alt.umpQty != null) {
          <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.COLUMNS.PACKAGING_UOM_LABEL' | t: { value: hasQuantity(m) ? ((alt.umpQty | dgNumber: 'stock') + ' ' + alt.umpCode) : alt.umpCode } }}</span>
          }
          }
          </div>
        </div>

        <div class="mt-3 flex flex-col gap-2 border-t pt-3 text-sm">
          @if (data.showStock) {
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.FIELDS.AVAILABLE_STOCK' | t }}</span>
            <span class="font-semibold" [class.text-green-600]="stockInUnit(m) > 0"
              [class.text-red-500]="stockInUnit(m) <= 0">
              {{ stockInUnit(m) | dgNumber:'stock' }}
            </span>
          </div>
          }
          <div class="flex items-center justify-between gap-2">
            <span class="text-secondary">{{ 'DOCUMENT_GENERATE.FIELDS.PRICE' | t }}</span>
            <span class="flex items-center gap-2">
              @if (m.hasPrice === false) {
              <span class="rounded-full bg-red-100 px-2 py-0.5 text-[10px] font-semibold text-red-700 dark:bg-red-900/40 dark:text-red-300">{{ 'DOCUMENT_GENERATE.BADGES.NO_PRICE' | t }}</span>
              }
              <span class="font-semibold">L.&nbsp;{{ price(m) | dgNumber }}</span>
            </span>
          </div>
        </div>
      </div>
      } @empty {
      <div class="text-secondary flex h-40 items-center justify-center px-4 text-center text-sm">
        {{ 'DOCUMENT_GENERATE.PRODUCT_SEARCH_MODAL.NO_RESULTS' | t }}
      </div>
      }
    </div>
  </div>

  <!-- results, desktop/tablet: tabla -->
  <div #resultsScroll class="hidden min-h-0 flex-1 overflow-auto border-t md:block" cdkScrollable>
    <table class="w-full min-w-[720px] table-fixed border-collapse text-base">
      <thead class="sticky top-0 z-10 bg-gray-50 dark:bg-gray-800">
        <tr class="text-secondary text-left">
          <th class="w-12 px-4 py-3">
            <mat-checkbox [checked]="allSelected()" (change)="toggleAll($event.checked)"></mat-checkbox>
          </th>
          <th class="w-[30%] px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.PRODUCT' | t }}</th>
          <th class="w-[30%] px-4 py-3 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.SALE_UOM' | t }}</th>
          <th class="w-24 px-4 py-3 text-center font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.QUANTITY' | t }}</th>
          @if (data.showStock) {
          <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.AVAILABLE_STOCK' | t }}</th>
          }
          <th class="px-4 py-3 text-right font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.PRICE' | t }}</th>
        </tr>
      </thead>
      <tbody>
        @for (m of materials; track m._id) {
        <tr class="border-t align-top"
          [ngClass]="selectable(m) ? 'cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800/40' : 'opacity-50'"
          [class.bg-primary-50]="isSelected(m)" [class.dark:bg-primary-900]="isSelected(m)" (click)="toggle(m)">
          <td class="px-4 py-3">
            <mat-checkbox [checked]="isSelected(m)" [disabled]="!selectable(m)" (change)="toggle(m)"
              (click)="$event.stopPropagation()"></mat-checkbox>
          </td>
          <td class="px-4 py-3">
            <div class="flex min-w-0 flex-col">
              <span class="inline-flex items-center gap-1.5 text-primary font-semibold">{{ code(m) }}<app-bom-cell [material]="m" /></span>
              <span class="font-medium uppercase">{{ m.name }}</span>
              @if (category(m)) {
              <span class="text-secondary text-xs">{{ 'DOCUMENT_GENERATE.PRODUCT_SEARCH_MODAL.CATEGORY_PREFIX' | t }} {{ category(m) }}</span>
              }
            </div>
          </td>
          <td class="px-4 py-3">
            <mat-form-field appearance="fill" subscriptSizing="dynamic" class="w-full"
              (click)="$event.stopPropagation()">
              <input matInput [placeholder]="'DOCUMENT_GENERATE.PLACEHOLDERS.UNIT' | t" [matAutocomplete]="autoUnit"
                [disabled]="!selectable(m)" [ngModel]="unitSearchValue(m)" (ngModelChange)="onUnitInput(m, $event)"
                (blur)="onUnitBlur(m)" (click)="$event.stopPropagation()">
              <mat-autocomplete #autoUnit="matAutocomplete" (optionSelected)="onUnitPick(m, $event.option.value)">
                @for (u of filteredUnits(m); track u.id) {
                <mat-option [value]="u.name">
                  <span class="flex items-center gap-2">
                    <span class="truncate">{{ u.name }}</span>
                    @if (u.chip === 'BASE') {
                    <span class="rounded-full bg-green-100 px-2 py-0.5 text-[10px] font-semibold text-green-700 dark:bg-green-900/40 dark:text-green-300">{{ 'DOCUMENT_GENERATE.BADGES.BASE' | t }}</span>
                    } @else if (u.chip === 'SECUNDARIA') {
                    <span class="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-700 dark:bg-amber-900/40 dark:text-amber-300">{{ 'DOCUMENT_GENERATE.BADGES.SECONDARY' | t }}</span>
                    } @else if (u.chip === 'PARALELA') {
                    <span class="rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-semibold text-blue-700 dark:bg-blue-900/40 dark:text-blue-300">{{ 'DOCUMENT_GENERATE.BADGES.PARALLEL' | t }}</span>
                    }
                  </span>
                </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <div class="mt-1 flex flex-wrap gap-x-3">
              @if (altUnits(m); as alt) {
              <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.COLUMNS.BASE_UOM_LABEL' | t: { value: hasQuantity(m) ? ((alt.umbQty | dgNumber: 'stock') + ' ' + alt.umbCode) : alt.umbCode } }}</span>
              @if (alt.umsQty != null) {
              <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.COLUMNS.SECONDARY_UOM_LABEL' | t: { value: hasQuantity(m) ? ((alt.umsQty | dgNumber: 'stock') + ' ' + alt.umsCode) : alt.umsCode } }}</span>
              }
              @if (alt.umpQty != null) {
              <span class="text-secondary text-sm">{{ 'DOCUMENT_GENERATE.COLUMNS.PACKAGING_UOM_LABEL' | t: { value: hasQuantity(m) ? ((alt.umpQty | dgNumber: 'stock') + ' ' + alt.umpCode) : alt.umpCode } }}</span>
              }
              }
            </div>
          </td>
          <td class="px-4 py-3" (click)="$event.stopPropagation()">
            <mat-form-field appearance="fill" subscriptSizing="dynamic" class="w-full">
              <input #qtyInput matInput type="text" inputmode="decimal" class="text-center"
                [disabled]="!selectable(m)" [value]="quantityText(m)"
                (input)="setQuantity(m, qtyInput.value)">
            </mat-form-field>
          </td>
          @if (data.showStock) {
          <td class="px-4 py-3 text-right font-semibold" [class.text-green-600]="stockInUnit(m) > 0"
            [class.text-red-500]="stockInUnit(m) <= 0">
            {{ stockInUnit(m) | dgNumber:'stock' }}
          </td>
          }
          <td class="px-4 py-3 text-right font-semibold">
            @if (m.hasPrice === false) {
            <span class="mb-1 block rounded-full bg-red-100 px-2 py-0.5 text-[10px] font-semibold text-red-700 dark:bg-red-900/40 dark:text-red-300">{{ 'DOCUMENT_GENERATE.BADGES.NO_PRICE' | t }}</span>
            }
            L.&nbsp;{{ price(m) | dgNumber }}
          </td>
        </tr>
        } @empty {
        <tr>
          <td [attr.colspan]="data.showStock ? 5 : 4">
            <div class="text-secondary flex h-40 items-center justify-center text-sm">
              {{ 'DOCUMENT_GENERATE.PRODUCT_SEARCH_MODAL.EMPTY' | t }}
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  }

  <!-- footer -->
  <div class="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 border-t px-6"
    [ngClass]="shortScreen ? 'py-2' : 'py-4'">
    <button mat-stroked-button type="button" [disabled]="selectedCount() === 0" (click)="toggleSelectedView()">
      <mat-icon>{{ showingSelected ? 'arrow_back' : 'checklist' }}</mat-icon>
      @if (showingSelected) {
      <span>{{ 'DOCUMENT_GENERATE.PRODUCT_SEARCH_MODAL.BACK_TO_SEARCH' | t }}</span>
      } @else {
      <span [innerHTML]="'DOCUMENT_GENERATE.PRODUCT_SEARCH_MODAL.SELECTED_COUNT' | t: { count: selectedCount() }"></span>
      }
    </button>
    <div class="flex items-center gap-1">
      <button mat-icon-button type="button" [matTooltip]="'DOCUMENT_GENERATE.PAGINATION.PREVIOUS' | t" [disabled]="page <= 1 || loading"
        (click)="changePage(-1)">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <span class="text-secondary whitespace-nowrap text-sm">{{ page }} / {{ totalPages }}</span>
      <button mat-icon-button type="button" [matTooltip]="'DOCUMENT_GENERATE.PAGINATION.NEXT' | t" [disabled]="page >= totalPages || loading"
        (click)="changePage(1)">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
    <div class="flex gap-3">
      <button mat-stroked-button type="button" (click)="cancel()">{{ 'GENERAL.CANCEL' | t }}</button>
      <button mat-flat-button color="primary" type="button" [disabled]="selected.size === 0" (click)="confirm()">
        {{ 'DOCUMENT_GENERATE.PRODUCT_SEARCH_MODAL.ADD_SELECTED' | t }}
      </button>
    </div>
  </div>
</div>
